import * as React from "react";

import { getHiddenRendererClassNames } from "./HiddenRenderer.classNames";
import type { HiddenRendererProps } from "./HiddenRenderer.Props";

/**
 * Renders child content in a hidden container similar to Fabric's ResizeGroup. This allows for things like measurements of DOM
 * strucutures offscreen.
 */
export class HiddenRenderer<T> extends React.PureComponent<
  React.PropsWithChildren<HiddenRendererProps<T>>,
  {}
> {
  private renderCache: { [cacheKey: string]: any } = {};

  public render() {
    // Don't need to put stuff in the DOM if we've previously rendered it
    if (
      (this.props.cacheKey && this.props.cacheKey in this.renderCache) ||
      !this.props.onRendered
    ) {
      return null;
    }

    const classNames = getHiddenRendererClassNames();

    return (
      <div className={classNames.root}>
        <div className={classNames.childrenContainer}>
          {this.props.children}
        </div>
      </div>
    );
  }

  public componentDidUpdate() {
    this.notifyRender();
  }

  public componentDidMount() {
    this.notifyRender();
  }

  public notifyRender(): void {
    if (!this.props.onRendered) {
      return;
    }

    if (this.props.cacheKey === undefined) {
      this.props.onRendered();
      return;
    }

    const cachedValue = this.renderCache[this.props.cacheKey];

    if (cachedValue) {
      this.props.onRendered(cachedValue);
    } else {
      const cacheValue = this.props.onRendered();
      this.renderCache[this.props.cacheKey] = cacheValue;
    }
  }
}
